import React from 'react';
import {useStyles} from './helper';

const ReplenishmentItem = ({item}) => {
    const classes = useStyles();
    const {login_user, count, sum_replenishment, sum_withdrawal, sum_withdrawal_air, sum_replenishment_air} = item;

    return (
        <div className={classes.root}>
            <div className={classes.wrapLogin}>
                <span className={classes.login}>{login_user}</span>
            </div>
            <div className={classes.wrapCount}>
                <span className={classes.helperCount}>
                    Колличество операций
                </span>
                <span className={classes.count}>
                    {count}
                </span>
            </div>
               
            <div className={classes.wrapDetalization}>
                <div className={classes.w50}>
                    <div className={classes.wrapHelper}>
                        <span className={classes.labelHelper}>Наличные</span>
                    </div>
                   
                    <div className={classes.flexBox}>
                        <span className={classes.helperAmount}>Вход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(Math.floor(+sum_replenishment ? +sum_replenishment.toFixed(2) : sum_replenishment))}  
                        </span>
                    </div>
                    <div className={classes.flexBox}>
                        <span className={classes.helperAmount}>Выход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(Math.floor(+sum_withdrawal ? +sum_withdrawal.toFixed(2) : sum_withdrawal))}  
                        </span>
                    </div>
                    <div className={classes.flexBox}>
                        <span className={classes.helperAmount}>Разница:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(Math.floor((+sum_replenishment - +sum_withdrawal).toFixed(2)))}  
                        </span>
                    </div>
                </div>
                <div className={classes.w50}>
                    <div className={classes.wrapHelper}>
                        <span className={classes.labelHelper}>Воздух</span>
                    </div>
                   
                    <div className={classes.flexBox}>
                        <span className={classes.helperAmount}>Вход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(Math.floor(+sum_replenishment_air ? +sum_replenishment_air.toFixed(2) : sum_replenishment_air))} 
                        </span>
                    </div>
                    <div className={classes.flexBox}>
                        <span className={classes.helperAmount}>Выход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(Math.floor(+sum_withdrawal_air ? +sum_withdrawal_air.toFixed(2) : sum_withdrawal_air))}
                        </span>
                    </div>
                    <div className={classes.flexBox}>
                        <span className={classes.helperAmount}>Разница:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(Math.floor((+sum_replenishment_air - +sum_withdrawal_air).toFixed(2)))}  
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReplenishmentItem;